export enum Orientation {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
  UNDEFINED = "",
}

export const lockOrientation = async (
  orientation: Orientation = Orientation.UNDEFINED
): Promise<Orientation> => {
  let orientationToSet =
    orientation !== Orientation.UNDEFINED
      ? orientation
      : (localStorage.getItem("orientation") as Orientation) ||
        Orientation.PORTRAIT;

  try {
    const lockOrientationValue =
      orientationToSet === Orientation.LANDSCAPE ? "landscape" : "portrait";

    // @ts-expect-error lock exists
    if (screen.orientation && typeof screen.orientation.lock === "function") {
      // @ts-expect-error lock exists
      await screen.orientation.lock(lockOrientationValue);
    } else {
      console.warn("Screen orientation lock is not supported on this device.");
    }
  } catch (error) {
    console.error("Failed to lock screen orientation:", error);
    console.info("Defaulting to portrait orientation.");
    orientationToSet = Orientation.PORTRAIT;
  }

  localStorage.setItem("orientation", orientationToSet);

  return orientationToSet;
};
